<script setup>
import { breadcrumbsFromURL } from '@/composables/helpers/urls'

const props = defineProps({
    light: Boolean,
})

const route = useRoute()
const breadcrumbs = ref(breadcrumbsFromURL(route.path))
const params = { url: btoa(route.path) }

const { status, data } = await useLazyAsyncData('breadcrumbs', () => $fetch('/api/breadcrumbs', { params: params }), { server: false })

useSchemaOrg([ defineBreadcrumb({ itemListElement: breadcrumbs.value }) ])

const removeTrailingSlashes = (str) => { return str.replace(/\/+$/, ''); }

watch(data, () => {
    breadcrumbs.value = data.value.map(item => ({
        name: item.breadcrumb_name ? item.breadcrumb_name : item.name,
        item: item.url,
    }))
})

</script>

<template>
    <!-- TODO: Re-enable breadcrumbs when 2026 design is ready -->
    <ProjectManualBreadcrumbs v-if="false && breadcrumbs && breadcrumbs.length > 1" :breadcrumbs="breadcrumbs" :light="light" />
</template>